export default __webpack_public_path__ + "static/media/Rose-Cake-3.25271333.jpg";